import { useState } from "react";
import React, { useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LandingPage from "web/pages/public/landing-page";
import WhoItFor from "web/pages/public/landing-page/WhoItFor";
import HowItWork from "web/pages/public/landing-page/HowItWork";
import NewsRoom from "web/pages/public/landing-page/NewsRoom";
import SearchInventory from "web/pages/public/landing-page/SearchInventory";
import FoundersCircle from "web/pages/public/landing-page/FoundersCircle";
import PalletSupplier from "web/pages/public/landing-page/PalletSupplier";
import PalletBuyerSolution from "web/pages/public/landing-page/PalletBuyer";
import About from "web/pages/public/landing-page/About";
import Auth from "web/pages/account/Auth";
import Registration from "web/pages/account/registration";
import PageNotFound from "web/pages/private/CommonPages/PageNotFound";
import NoAccessToPage from "web/pages/private/CommonPages/NoAccessToPage";
import SignUpDetail from "web/pages/public/landing-page/SignUp";
import PrivacyPolicy from "web/pages/public/landing-page/LandingFooter/PrivacyPolicy";
import TermsOfUse from "web/pages/public/landing-page/LandingFooter/WebsiteTermsofUse";
import FeaturedAmbassador from "web/pages/public/landing-page/FoundersCircle/FeaturedAmbassador";
import UnsubscibeNewsletter from "web/pages/public/UnsubscibeNewsletter";
import WsjLink from "web/pages/public/landing-page/NewsRoom/WsjLink";
import Dashboard from "web/pages/private/Dashboard";
import Admin from "web/pages/private/Admin";
import SignUp from "web/pages/private/Admin/AdminRoles/SignUp";
import CustomerReviews from "web/pages/private/CommonPages/CustomerReviews";
import PaymentMethod from "web/pages/account/payment-method";
import ConfirmPassword from "web/pages/account/confirm-password";
import ClaimRaise from "web/pages/private/CommonPages/ClaimRaise";
import ManageAccounts from "web/pages/account/account-settings/manage-accounts";
import PostLoad from "web/pages/private/Dashboard/PostLoad";
import OpertaionalTC from "web/pages/private/CommonPages/OpertaionalTC";
import Specification from "web/pages/private/CommonPages/SpecificationV1";
import PalletSpecification from "web/pages/private/CommonPages/PalletSpecification";
import PostInventory from "web/pages/private/Dashboard/PostInventory";
import Details from "web/pages/private/CommonPages/Details/index";

import SelfManaged from "web/pages/public/landing-page/SelfManaged";
import ManagedServices from "web/pages/public/landing-page/ManagedServices";
import CustomizedSolutions from "web/pages/public/landing-page/CustomizedSolutions";

// import InventoryDetails from "web/pages/private/CommonPages/Details/indexInventory";

import Groups from "web/pages/private/CommonPages/Groups";

// import Checkout from "web/pages/private/CommonPages/Checkout";
import Checkoutv2 from "web/pages/private/CommonPages/Checkoutv2";
// import MyBids from "web/pages/private/CommonPages/MyBids";
// import MyPost from "web/pages/private/CommonPages/MyPost";
import MyPostLoad from "web/pages/private/CommonPages/MyPostLoad";
import MyInventories from "web/pages/private/CommonPages/MyInventories";

import HealthCheck from "web/pages/private/CommonPages/HealthCheck";
import MyOfferInventoryBids from "web/pages/private/CommonPages/MyOfferInventoryBids";
import MyOfferPostBids from "web/pages/private/CommonPages/MyOfferPostBids";

import MyOrder from "web/pages/private/CommonPages/MyOrder";
import MyPickupOrder from "web/pages/private/CommonPages/MyPickupOrders";
import OrderDetails from "web/pages/private/CommonPages/PtPlus/OrderDetails";
import RequestOrder from "web/pages/private/CommonPages/PtPlus/RequestOrder";
import RequestPickupOrder from "web/pages/private/CommonPages/PtPlus/RequestPickupOrder";
import ModifyRequest from "web/pages/private/CommonPages/PtPlus/RequestOrder/modifyRequest";

// import Profile from "web/pages/private/CommonPages/ManageAccount/Profile";
// import PaymentDetail from "web/pages/private/CommonPages/PaymentDetail";
import ManageAccount from "web/pages/private/CommonPages/ManageAccount";
// import SearchPostScreen from "web/pages/private/CommonPages/SearchPostScreen";
import NeadByInventory from "web/pages/private/CommonPages/NeadByInventory";

// import SearchPostLoadScreen from "web/pages/private/CommonPages/SearchPostScreen/indexPostLoad";
import NearByNeeds from "web/pages/private/CommonPages/NeadByNeed";
import WishList from "web/pages/private/CommonPages/WishList";

import MyNetworks from "web/pages/private/CommonPages/MyNetworks";
import NetworkRequests from "web/pages/private/CommonPages/MyNetworks/NetworkRequests";
import OrderReportsFront from "web/pages/private/CommonPages/OrderReports";
import Notification from "web/pages/private/CommonPages/Notification";
import Faq from "web/pages/private/CommonPages/Faq";
import ReferralPage from "web/pages/private/CommonPages/ReferralPage";
import { GUEST, SECURED } from "web/components/Router/constants";
import { toggleGuestUpgradeModal } from "redux/actions/app";
import MembershipPlans from "../MembershipPlans";
import AlertModal from "../AlertModal";
import PickupOrderTC from "web/pages/private/CommonPages/Checkoutv2/SellerPickupOrder/PickupOrderTerms";

const ReactRouter = (props) => {
  const dispatch = useDispatch();
  const showingGuestUpgradeModal = useSelector(
    (state) => state.appReducer.showGuestMembershipUpgradeModal
  );
  let loggedUserInnerCircle = true;

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => {
    setModal(!modal);
    dispatch(toggleGuestUpgradeModal(!modal));
  };
  let title = "Pending Approval";

  const [membershipModal, setMembershipModal] = useState(false);

  const accountType = localStorage.getItem("accountType");
  const approvalStatus = localStorage.getItem("approvalStatus");

  const membershipToggleModal = () => {
    if (accountType === "Guest" && approvalStatus === "REQUEST_FOR_APPROVAL") {
      const content = (
        <>
          <p>
            Your request is pending with PalletTrader Administration team for
            review. You will recieve a confirmation email once your account has
            been activated.
          </p>
        </>
      );
      setModalContent(content);
      setModalLink("");
      toggleModal();
    } else {
      setMembershipModal(!membershipModal);
      dispatch(toggleGuestUpgradeModal(!membershipModal));
    }
  };

  useEffect(() => {
    if (showingGuestUpgradeModal) membershipToggleModal();
  }, [showingGuestUpgradeModal]);

  return (
    <div className="App">
      <BrowserRouter>
        {showingGuestUpgradeModal && (
          <>
            <MembershipPlans
              isOpen={membershipModal}
              toggle={membershipToggleModal}
              pageType="upgradeGuest"
              callBackToRegistration={(_val) => membershipToggleModal()}
              memeberType="upgradeGuest"
            />
            <AlertModal
              isOpen={modal}
              toggle={toggleModal}
              title={title}
              content={modalContent}
              link={modalLink}
            />
          </>
        )}

        <Switch>
          <Route exact path="/" component={LandingPage} type={GUEST} />
          <Route
            exact
            path="/contact-us"
            component={SignUpDetail}
            type={GUEST}
          />
          <Route exact path="/signup" component={SignUpDetail} type={GUEST} />
          <Route
            exact
            path="/privacy-policy"
            component={PrivacyPolicy}
            type={GUEST}
          />
          <Route
            exact
            path="/terms-of-use"
            component={TermsOfUse}
            type={GUEST}
          />
          <Route
            exact
            path="/featured-ambassador"
            component={FeaturedAmbassador}
            type={GUEST}
          />

          <Route path="/landing-page" component={LandingPage} type={GUEST} />
          <Route path="/who-its-for" component={WhoItFor} type={GUEST} />
          <Route path="/how-it-works" component={HowItWork} type={GUEST} />
          <Route
            path="/founders-circle"
            component={FoundersCircle}
            type={GUEST}
          />
          <Route
            path="/pallet-supplier-and-broker-solutions"
            component={PalletSupplier}
            type={GUEST}
          />
          <Route
            path="/pallet-buyer-solutions"
            component={PalletBuyerSolution}
            type={GUEST}
          />

          <Route path="/about-us" component={About} type={GUEST} />
          <Route path="/self-managed-services" component={SelfManaged} type={GUEST} />
          <Route
            path="/customized-pallet-solutions"
            component={CustomizedSolutions}
            type={GUEST}
          />
          <Route
            path="/managed-services"
            component={ManagedServices}
            type={GUEST}
          />

          <Route path="/newsroom" component={NewsRoom} type={GUEST} />

          <Route path="/wsj-link" component={WsjLink} type={GUEST} />

          <Route path="/sign-in" component={Auth} type={GUEST} />
          <Route path="/registration" component={Registration} type={GUEST} />
          <Route
            path="/post-my-pallet-needs"
            component={loggedUserInnerCircle ? PostLoad : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/post-my-pallet-inventory"
            component={loggedUserInnerCircle ? PostInventory : NoAccessToPage}
            type={SECURED}
          />

          <Route path="/Admin" component={Admin} type={SECURED} />
          <Route path="/users" component={Admin} type={SECURED} />
          <Route path="/detailedUserInfo" component={Admin} type={SECURED} />
          <Route path="/user-activity" component={Admin} type={SECURED} />
          <Route path="/location-management" component={Admin} type={SECURED} />
          <Route path="/supplier-fee-management" component={Admin} type={SECURED} />
          <Route path="/new-invitations" component={Admin} type={SECURED} />
          {/* <Route path="/admin-posts" component={Admin} type={SECURED} /> */}
          <Route path="/admin-post-module" component={Admin} type={SECURED} />
          <Route path="/retry-orders" component={Admin} type={SECURED} />
          <Route path="/cancel-orders" component={Admin} type={SECURED} />
          <Route path="/adminAccessSignUp" component={SignUp} />
          <Route path="/reports" component={Admin} type={SECURED} />
          <Route path="/subscriptionReports" component={Admin} type={SECURED} />
          <Route path="/commissionReport" component={Admin} type={SECURED} />
          <Route path="/purchaseReports" component={Admin} type={SECURED} />
          <Route path="/orderReports" component={Admin} type={SECURED} />
          <Route path="/pickupOrderReports" component={Admin} type={SECURED} />
          <Route path="/claimReports" component={Admin} type={SECURED} />
          <Route
            path="/loadInventoryReports"
            component={Admin}
            type={SECURED}
          />
          <Route path="/referralsReports" component={Admin} type={SECURED} />
          <Route
            path="/userSubscriptionList"
            component={Admin}
            type={SECURED}
          />
          <Route path="/orderDetailList" component={Admin} type={SECURED} />
          <Route path="/content-moderation" component={Admin} type={SECURED} />
          <Route path="/claim" component={Admin} type={SECURED} />
          <Route path="/quotes" component={Admin} type={SECURED} />
          <Route path="/subscription" component={Admin} type={SECURED} />
          <Route path="/promo-code" component={Admin} type={SECURED} />
          <Route path="/referral-code" component={Admin} type={SECURED} />
          <Route path="/app-non-user" component={Admin} type={SECURED} />
          <Route
            path="/terms-and-conditions"
            component={Admin}
            type={SECURED}
          />
          <Route
            path="/language-localization"
            component={Admin}
            type={SECURED}
          />
          <Route path="/chat-block" component={Admin} type={SECURED} />
          <Route path="/chats-order" component={Admin} type={SECURED} />
          <Route
            path="/adminCustomerReviews"
            component={Admin}
            type={SECURED}
          />

          {/* admin pt plus pages */}
          <Route
            path="/ptplus-user-managememt"
            component={Admin}
            type={SECURED}
          />
          <Route
            path="/ptplus-order-request-managememt"
            component={Admin}
            type={SECURED}
          />
          <Route
            path="/ptplus-order-request"
            component={Admin}
            type={SECURED}
          />
          <Route path="/ptplus-invoices" component={Admin} type={SECURED} />
          <Route path="/ptplus-reports" component={Admin} type={SECURED} />
          <Route path="/ptplus-buyback-fee" component={Admin} type={SECURED} />
          <Route path="/ptplus-vendor-pricing" component={Admin} type={SECURED} />
          <Route
            path="/ptplus-admin-request-pickup-order"
            component={Admin}
            type={SECURED}
          />
          <Route
            path="/notification"
            component={loggedUserInnerCircle ? Notification : NoAccessToPage}
            type={SECURED}
          />

          {/* <Route
            path="/specifications"
            component={Specification}
            type={SECURED}
          /> */}
          <Route
            path="/specifications"
            component={PalletSpecification}
            type={SECURED}
          />
          <Route
            path="/refer-a-friend"
            component={ReferralPage}
            type={SECURED}
          />
          <Route path="/faqs" component={Faq} type={SECURED} />
          <Route path="/dashboard" component={Dashboard} type={GUEST} />
          {/* <Route
            path="/MyPost"
            component={loggedUserInnerCircle ? MyPost : NoAccessToPage}
            type={SECURED}
          /> */}
          <Route
            path="/my-posted-pallet-needs"
            component={loggedUserInnerCircle ? MyPostLoad : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/my-posted-pallet-inventory"
            component={loggedUserInnerCircle ? MyInventories : NoAccessToPage}
            type={SECURED}
          />

          <Route
            path="/my-orders"
            component={loggedUserInnerCircle ? MyOrder : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/my-pickup-orders"
            component={loggedUserInnerCircle ? MyPickupOrder : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/view-my-offers-on-pallet-inventory"
            component={
              loggedUserInnerCircle ? MyOfferInventoryBids : NoAccessToPage
            }
            type={SECURED}
          />
          <Route
            path="/view-my-bids-on-pallet-needs"
            component={loggedUserInnerCircle ? MyOfferPostBids : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/resolution-center"
            component={loggedUserInnerCircle ? ClaimRaise : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/order-reports"
            component={
              loggedUserInnerCircle ? OrderReportsFront : NoAccessToPage
            }
            type={SECURED}
          />

          <Route path="/health-check" component={HealthCheck} type={SECURED} />
          <Route
            path="/details"
            component={loggedUserInnerCircle ? Details : NoAccessToPage}
            type={SECURED}
          />

          {/* <Route
            path="/inventory-details"
            component={loggedUserInnerCircle ? InventoryDetails : NoAccessToPage}
            type={SECURED}
          /> */}

          <Route path="/Groups" component={Groups} type={SECURED} />
          <Route path="/my-community" component={MyNetworks} type={SECURED} />
          <Route
            path="/search-inventory"
            component={SearchInventory}
            type={SECURED}
          />

          <Route
            path="/NetworkRequests"
            component={NetworkRequests}
            type={SECURED}
          />

          {/* <Route
            path="/checkout"
            component={loggedUserInnerCircle ? Checkout : NoAccessToPage}
            type={SECURED}
          /> */}
          <Route
            path="/checkout"
            component={loggedUserInnerCircle ? Checkoutv2 : NoAccessToPage}
            type={SECURED}
          />

          {/* <Route path="/profile" component={Profile} type={SECURED} />
          <Route
            path="/PaymentDetail"
            component={PaymentDetail}
            type={SECURED}
          /> */}
          <Route
            path="/manage-account"
            component={ManageAccount}
            type={SECURED}
          />
          <Route
            path="/nearby-inventory"
            component={loggedUserInnerCircle ? NeadByInventory : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/wish-list"
            component={loggedUserInnerCircle ? WishList : NoAccessToPage}
            type={SECURED}
          />
          <Route
            path="/nearby-needs"
            component={loggedUserInnerCircle ? NearByNeeds : NoAccessToPage}
            type={SECURED}
          />

          {/* <Route
            path="/MyBids"
            component={loggedUserInnerCircle ? MyBids : NoAccessToPage}
            type={SECURED}
          /> */}

          {/* dont remove this, eventhough this is not used, css styling is pulled in stripe card details file */}
          {/* so until optimize by seperating the css file dont use remove this */}
          <Route
            path="/payment-method"
            component={PaymentMethod}
            type={SECURED}
          />

          <Route
            path="/confirm-password"
            component={ConfirmPassword}
            type={GUEST}
          />
          <Route
            path="/checkout-terms-and-conditions"
            component={PickupOrderTC}
            type={GUEST}
          />
          <Route
            path="/operational-terms-and-conditions"
            component={OpertaionalTC}
            type={GUEST}
          />
          <Route
            path="/customer-reviews"
            component={CustomerReviews}
            type={SECURED}
          />
          <Route
            path="/manage-users-and-locations"
            component={ManageAccounts}
            type={SECURED}
          />
          <Route
            path="/unsubscribe-newsletter"
            component={UnsubscibeNewsletter}
            type={GUEST}
          />
          <Route
            path="/ptplus-order-details"
            component={OrderDetails}
            type={GUEST}
          />
          <Route
            path="/ptplus-request-order"
            component={RequestOrder}
            type={GUEST}
          />
          <Route
            path="/ptplus-request-order-modify"
            component={ModifyRequest}
            type={GUEST}
          />
          <Route
            path="/ptplus-request-pickup-order"
            component={RequestPickupOrder}
            type={GUEST}
          />
          <Route path="*" component={PageNotFound} type={GUEST} />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default ReactRouter;
